module.exports = __webpack_public_path__ + "media/images/game/kolo_1-9ff3edaf922cfd6ca72a00b55d435577.png";